import {
  BILLING_PERIOD_QUERY_PARAM,
  type BillingPeriod,
  normalizeBillingPeriod,
  PLUS_UPGRADE_QUERY_PARAM,
  PLUS_UPGRADE_QUERY_VALUE,
} from "@sill/shared/components/billing/pricing-copy";

export type UpgradeIntent = {
  billingPeriod: BillingPeriod;
};

export function getUpgradeIntent(search: string): UpgradeIntent | null {
  const params = new URLSearchParams(search);
  if (params.get(PLUS_UPGRADE_QUERY_PARAM) !== PLUS_UPGRADE_QUERY_VALUE) {
    return null;
  }

  return {
    billingPeriod:
      normalizeBillingPeriod(params.get(BILLING_PERIOD_QUERY_PARAM)) ??
      "monthly",
  };
}

export function getUpgradeIntentDestination(search: string): string | null {
  const intent = getUpgradeIntent(search);
  if (!intent) return null;

  return `/dashboard/settings?${buildUpgradeIntentSearch(intent)}#subscription`;
}

export function getOnboardingPathWithUpgradeIntent(search: string): string {
  const intent = getUpgradeIntent(search);
  if (!intent) return "/onboarding";

  return `/onboarding?${buildUpgradeIntentSearch(intent)}`;
}

export function buildUpgradeIntentSearch(intent: UpgradeIntent): string {
  const params = new URLSearchParams();
  params.set(PLUS_UPGRADE_QUERY_PARAM, PLUS_UPGRADE_QUERY_VALUE);
  params.set(BILLING_PERIOD_QUERY_PARAM, intent.billingPeriod);
  return params.toString();
}

export function stripUpgradeIntentFromPath(
  pathname: string,
  search: string,
  hash: string,
): string {
  const params = new URLSearchParams(search);
  params.delete(PLUS_UPGRADE_QUERY_PARAM);
  params.delete(BILLING_PERIOD_QUERY_PARAM);
  const nextSearch = params.toString();
  return `${pathname}${nextSearch ? `?${nextSearch}` : ""}${hash}`;
}
